import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from 'spa-ionata-admin/lib/models/ApplicationRecord';
import User from './User';
import Business from './Business';

@Model()
export default class EoiLead extends ApplicationRecord {
  static jsonapiType = 'eoi-leads';

  // --- Attributes
  // --------------

  // required
  @Attr() firstName!: string;

  // required
  @Attr() lastName!: string;

  // required
  // maxLength: 254
  @Attr() email!: string;

  // required
  @Attr() businessName!: string;

  @Attr() content!: HashAny | null;

  // readOnly
  @Attr() createdAt!: string | null;

  // readOnly
  @Attr() modifiedAt!: string | null;

  // --- Relationships
  // -----------------

  // nullable
  @HasOne() business!: Business | null;

  // nullable
  @HasOne() createdBy!: User | null;

  // nullable
  @HasOne() modifiedBy!: User | null;

  // --- Paths
  // ---------

  /**
   * /backend/api/v1/eoi-leads/
   *
   * Method: post
   * Body:
   *   - first_name: string (required)
   *   - last_name: string (required)
   *   - email: string (format: email) (maxLength: 254) (required)
   *   - business_name: string (required)
   *   - content: object
   *
   */
}
